import { Injectable } from "@angular/core";
import { PlacardEditionRequest } from "../../api/models/placardEdit";
import { PlacardVerification } from "../../interface/upplm.placardInformation";

@Injectable()

export class PlacardVerificationHelperService {

    constructor() { }

    preparePlacardVerificationDataForEdit(data: PlacardVerification): PlacardVerification {

        return data;
    }

    prepareSaveEditionRequest(dataEdited: any): PlacardEditionRequest {

        let placardEditionRequest = new PlacardEditionRequest();

        placardEditionRequest.placardImage = dataEdited.placardImage;
        
        return placardEditionRequest;
    }

}